import React, { useContext } from "react";

import css from "./Topbar.module.css";
import logoName from "../../assets/mairiniLogoName.png";
import logoNameSVG from "../../assets/logo512.png";
import { Link, useLocation } from "react-router-dom";
import { UserContext } from "../../Context/UserContext";

export const Topbar = () => {
  const { userData } = useContext(UserContext);
  const { pathname } = useLocation();

  return (
    <nav className={css.nav}>
      <a href="/" className={css.logo}>
        <img src={logoName} alt="" />
      </a>
      <a href="/" className={css.logoColapsed}>
        <img src={logoNameSVG} alt="" />
      </a>
      <ul className={css.menuColapsed}>
        <div>
          {userData ? (
            <Link to={userData ? "/" : "/start"} className={css.link}>
              <li
                className={
                  pathname === "/" || pathname === "/start"
                    ? `${css.topbarListItem} ${css.active}`
                    : `${css.topbarListItem}`
                }
              >
                <i
                  className={
                    pathname === "/" || pathname === "/start"
                      ? `material-icons ${css.topbarIcon} ${css.active}`
                      : `material-icons ${css.topbarIcon}`
                  }
                >
                  home
                </i>
              </li>
            </Link>
          ) : (
            <li
              className={
                pathname === "/" || pathname === "/start"
                  ? `${css.topbarListItem} ${css.active}`
                  : `${css.topbarListItem} ${css.disabled}`
              }
            >
              <i
                className={
                  pathname === "/" || pathname === "/start"
                    ? `material-icons ${css.topbarIcon} ${css.active}`
                    : `material-icons ${css.topbarIcon} ${css.disabled}`
                }
              >
                home
              </i>
            </li>
          )}
          {userData && (
            <Link to={"/schedule"} className={css.link}>
              <li
                className={
                  pathname === "/schedule"
                    ? `${css.topbarListItem} ${css.active}`
                    : `${css.topbarListItem}`
                }
              >
                <i
                  className={
                    pathname === "/schedule"
                      ? `material-icons ${css.topbarIcon} ${css.active}`
                      : `material-icons ${css.topbarIcon}`
                  }
                >
                  insights
                </i>
              </li>
            </Link>
          )}
          {userData && (
            <Link to="/profile" className={css.link}>
              <li
                className={
                  pathname === "/profile"
                    ? `${css.topbarListItem} ${css.active}`
                    : `${css.topbarListItem}`
                }
              >
                <i
                  className={
                    pathname === "/profile"
                      ? `material-icons ${css.topbarIcon} ${css.active}`
                      : `material-icons ${css.topbarIcon}`
                  }
                >
                  person
                </i>
              </li>
            </Link>
          )}
        </div>
        <div>
          {userData && (
            <Link to="/account" className={css.link}>
              <li
                className={
                  pathname === "/account"
                    ? `${css.topbarListItem} ${css.active}`
                    : css.topbarListItem
                }
              >
                <i
                  className={
                    pathname === "/account"
                      ? `material-icons ${css.topbarIcon} ${css.active}`
                      : `material-icons ${css.topbarIcon}`
                  }
                >
                  settings
                </i>
              </li>
            </Link>
          )}

          {
            <Link to="/contact" className={css.link}>
              <li
                className={
                  pathname === "/contact"
                    ? `${css.topbarListItem} ${css.active}`
                    : css.topbarListItem
                }
              >
                <i
                  className={
                    pathname === "/contact"
                      ? `material-icons ${css.topbarIcon} ${css.active}`
                      : `material-icons ${css.topbarIcon}`
                  }
                >
                  call
                </i>
              </li>
            </Link>
          }

          {userData ? (
            <Link to="/logout" className={css.link}>
              <li className={css.topbarListItem}>
                <i className={`material-icons ${css.topbarIcon}`}>logout</i>
              </li>
            </Link>
          ) : (
            <Link to="/login" className={css.link}>
              <li className={css.topbarListItem}>
                <i className={`material-icons ${css.topbarIcon}`}>login</i>
              </li>
            </Link>
          )}
        </div>
      </ul>

      <ul className={css.menu}>
        <div>
          {userData ? (
            <Link to={userData ? "/" : "/start"} className={css.link}>
              <li
                className={
                  pathname === "/" || pathname === "/start"
                    ? `${css.topbarListItem} ${css.active}`
                    : `${css.topbarListItem}`
                }
              >
                <i
                  className={
                    pathname === "/" || pathname === "/start"
                      ? `material-icons ${css.topbarIcon} ${css.active}`
                      : `material-icons ${css.topbarIcon}`
                  }
                >
                  home
                </i>
                Início
              </li>
            </Link>
          ) : (
            <li
              className={
                pathname === "/" || pathname === "/start"
                  ? `${css.topbarListItem} ${css.active}`
                  : `${css.topbarListItem} ${css.disabled}`
              }
            >
              <i
                className={
                  pathname === "/" || pathname === "/start"
                    ? `material-icons ${css.topbarIcon} ${css.active}`
                    : `material-icons ${css.topbarIcon} ${css.disabled}`
                }
              >
                home
              </i>
              Início
            </li>
          )}
          {userData && (
            <Link to={"/schedule"} className={css.link}>
              <li
                className={
                  pathname === "/schedule"
                    ? `${css.topbarListItem} ${css.active}`
                    : `${css.topbarListItem}`
                }
              >
                <i
                  className={
                    pathname === "/schedule"
                      ? `material-icons ${css.topbarIcon} ${css.active}`
                      : `material-icons ${css.topbarIcon}`
                  }
                >
                  insights
                </i>
                Diário
              </li>
            </Link>
          )}
          {userData && (
            <Link to="/profile" className={css.link}>
              <li
                className={
                  pathname === "/profile"
                    ? `${css.topbarListItem} ${css.active}`
                    : `${css.topbarListItem}`
                }
              >
                <i
                  className={
                    pathname === "/profile"
                      ? `material-icons ${css.topbarIcon} ${css.active}`
                      : `material-icons ${css.topbarIcon}`
                  }
                >
                  person
                </i>
                Perfil
              </li>
            </Link>
          )}
        </div>
        <div>
          {userData && (
            <Link to="/account" className={css.link}>
              <li
                className={
                  pathname === "/account"
                    ? `${css.topbarListItem} ${css.active}`
                    : css.topbarListItem
                }
              >
                <i
                  className={
                    pathname === "/account"
                      ? `material-icons ${css.topbarIcon} ${css.active}`
                      : `material-icons ${css.topbarIcon}`
                  }
                >
                  settings
                </i>
                Conta
              </li>
            </Link>
          )}

          {
            <Link to="/contact" className={css.link}>
              <li
                className={
                  pathname === "/contact"
                    ? `${css.topbarListItem} ${css.active}`
                    : css.topbarListItem
                }
              >
                <i
                  className={
                    pathname === "/contact"
                      ? `material-icons ${css.topbarIcon} ${css.active}`
                      : `material-icons ${css.topbarIcon}`
                  }
                >
                  call
                </i>
                Contato
              </li>
            </Link>
          }

          {userData ? (
            <Link to="/logout" className={css.link}>
              <li className={css.topbarListItem}>
                <i className={`material-icons ${css.topbarIcon}`}>logout</i>
                Sair
              </li>
            </Link>
          ) : (
            <Link to="/login" className={css.link}>
              <li className={css.topbarListItem}>
                <i className={`material-icons ${css.topbarIcon}`}>login</i>
                Entrar
              </li>
            </Link>
          )}
        </div>
      </ul>
    </nav>
  );
};
